import Immutable from 'immutable';

export type DocId = string;

export interface RawDoc {
  documentid: string;
  projectid: string;
  title: string;
  filename: string;
  filesize: number;
  uploader: string;
  uploadtimestamp: number;
  processrequestid: string;
  error: string;
  errorTimetamp: number;
}

export interface DocData {
  documentid: string;
  projectid: string;
  title: string;
  filename: string;
  filesize: number;
  uploader: string;
  uploadtimestamp: number;
  processrequestid: string;
  error: string;
  errorTimetamp: number;
}

const defaultValues: DocData = {
  documentid: '',
  projectid: '',
  title: '',
  filename: '',
  filesize: 0,
  uploader: '',
  uploadtimestamp: 0,
  processrequestid: '',
  error: '',
  errorTimetamp: 0,
};

export const DocFactory = Immutable.Record(defaultValues, 'Doc');

export class Doc extends DocFactory {
  static deserialize(rawDoc: RawDoc): Doc {
    return new Doc({
      ...rawDoc,
    });
  }

  serialize(): RawDoc {
    return this.toJS();
  }
}

export type DocList = Immutable.List<Doc>;
